
import "./style.scss";
import { Container } from "react-bootstrap";
import { BiLogoFacebook } from "react-icons/bi";
import { RiTwitterXFill } from "react-icons/ri";
import { FaInstagram } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";
import Logo from "../../asset/images/ogTraillogo.png";
import Timer from "./time";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import { Button, notification, Space, Tag } from "antd";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/hooks";
import { logout } from "../../redux/slices/userSlice";
import ProfileModal from "./profileModal";
import { clearSubscriptions } from "../../redux/slices/subscription";
import moment from "moment";

const Header = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state: any) => state?.User?.user);

  const isAuthenticated = useSelector((state: any) => state.User.auth);

  const loggingout = () => {
    dispatch(logout({}));
    dispatch(clearSubscriptions());
    navigate("/");
    notification.success({
      message: "Success",
      description: "loggedout successfully.",
    });
  };

  const pressSubscribe = () => {
    if (isAuthenticated) {
      navigate("/subscribe");
    } else {
      navigate("/auth");
    }
  };

  // Check if the current route is the SubscriptionPlans page
  const isSubscriptionPlansPage = location.pathname === "/subscribe";

  return (
    <div className="Header">
      <Container>
        <div className="Header-box">
          {/* Left: Date (Desktop only) */}
          <div className="Header-box1">
            <div className="Header-date-text">
              {moment(new Date()).format("dddd DD, MMMM YYYY")}
            </div>
          </div>

          {/* Center: Logo */}
          <div className="Header-logo-container" onClick={() => navigate("/")}>
            <img src={Logo} className="Header-logo" alt="" />
          </div>

          {/* Right: Buttons + Social Icons */}
          <div className="Header-right">
            <div className="Header-buttons">
              <Space>
                {/* Conditionally render the Subscribe button */}
                {!isAuthenticated || !isSubscriptionPlansPage ? (
                  <Button
                    type="primary"
                    onClick={() => pressSubscribe()}
                    style={{
                      backgroundColor: "#b72c6f",
                    }}
                    // style={{ marginRight: "10px" }}
                  >
                    Subscribe
                  </Button>
                ) : null}
                {/* <Button type="primary" onClick={() => navigate("/epaper")}>
                  Epaper
                </Button> */}
              </Space>
            </div>
            <div className="Header-social-icons">
              {/* <div className="Header-icon">
                <a target="_blank" rel="noopener noreferrer">
                  <AiOutlineYoutube size={20} color="#000" />
                </a>
              </div> */}
              {/* <div className="Header-icon">
                <a target="_blank" rel="noopener noreferrer">
                  <RiTwitterXFill size={18} color="#000" />
                </a>
              </div> */}
              {/* <div className="Header-icon">
                <a target="_blank" rel="noopener noreferrer">
                  <FaInstagram size={20} color="#000" />
                </a>
              </div> */}
              {/* <div className="Header-icon">
                <a target="_blank" rel="noopener noreferrer">
                  <BiLogoFacebook size={20} color="#000" />
                </a>
              </div> */}
              <div className="Header-icon">
                {!user?.id ? (
                  <Button
                    style={{ color: " #b72c6f" }}
                    type="link"
                    onClick={() => navigate("/auth")}
                  >
                    Login
                  </Button>
                ) : (
                  <a>
                    <ProfileModal
                      auth={isAuthenticated}
                      open={() => navigate("/auth")}
                      logOut={() => loggingout()}
                      user={user}
                    />
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Mobile Profile Icon - Only visible on mobile */}
          <div className="Header-mobile-profile">
            <div className="Header-mobile-profile-icon">
              {!user?.id ? (
                <Button
                  style={{ color: "#b72c6f" }}
                  type="link"
                  onClick={() => navigate("/auth")}
                >
                  Login
                </Button>
              ) : (
                <ProfileModal
                  auth={isAuthenticated}
                  open={() => navigate("/auth")}
                  logOut={() => loggingout()}
                  user={user}
                />
              )}
            </div>
          </div>
        </div>
        {/* Mobile date row */}
        <div className="Header-mobile-date">
          <Timer onlyDate />
        </div>
      </Container>
    </div>
  );
};

export default Header;
